"use client"

import React, { useContext, useEffect } from "react"
import Signup from "@/components/Signup/Signup"

//UI Context
import { ModalContext } from "@/contexts/ModalProvider"
//Modal Container Component
import Modal from "./Modal"
import styles from "./SignupForm.module.scss"

export default function SignupForm({ isOnline, texts }) {
  const { openModal, setOpenModal } = useContext(ModalContext)

  function escClose(e) {
    if (openModal && e.code === "Escape") {
      setOpenModal(false)
    }
  }

  if (typeof window !== "undefined") {
    document.addEventListener("keydown", escClose)
  }

  useEffect(() => {
    document.addEventListener("keydown", escClose)
  }, [])

  return (
    <div className={styles.SignupForm}>
      <Modal>
        {/*Custom Modal Component*/}
        {openModal && (
          <div className={styles.SignupForm__form}>
            {/* <div
            className={styles.SignupForm__note}
            dangerouslySetInnerHTML={{ __html: texts.cancelled }}
          ></div> */}
            <Signup
              className={styles.SignupForm__signup}
              isOnline={isOnline}
              withRadio
              texts={texts}
            />
            <button
              type="button"
              className={styles.SignupForm__close}
              onClick={() => setOpenModal(false)}
            ></button>
          </div>
        )}
      </Modal>
    </div>
  )
}

// export default function SignupForm({ isOnline = false }) {
//   const [formOpen, setFormOpen] = useState(false)

//   const openForm = () => {
//     setFormOpen(true)
//     document.querySelector("body").classList.add("openForm")
//   }

//   const closeForm = () => {
//     setFormOpen(false)
//     document.querySelector("body").classList.remove("openForm")
//   }

//   function escClose(e) {
//     if (formOpen && e.code === "Escape") {
//       closeForm()
//     }
//   }

//   if (typeof window !== "undefined") {
//     document.addEventListener("keydown", escClose)
//   }

//   useEffect(() => {
//     document.addEventListener("keydown", escClose)
//   }, [])
//   return (
//     <div className={`${styles.intro__form} ${formOpen ? styles.show : ""}`}>
//       <Signup
//         className={styles.intro__signup}
//         isOnline={isOnline}
//         title="Join us"
//         thankyouText="Thank you for joining!"
//         withRadio
//         textAfter="Can’t attend in person? Register <a href='#'>here</a> to watch the webinar!"
//       />
//       <button
//         type="button"
//         className={styles.intro__close}
//         onClick={closeForm}
//       ></button>
//     </div>
//   )
// }
